class SiteHeader {
    constructor(el) {
        this.el = el;
        this.menuBar = this.el.querySelector('.menu-desktop');
        
        this.resizeObserver = new ResizeObserver(entries => {
            entries.forEach(entry => {
                switch (entry.target) {
                    case this.el:
                        this.headerHeight = Math.round(entry.contentBoxSize[0].blockSize);
                    break;
                    case this.menuBar:
                        this.barHeight = Math.round(entry.contentBoxSize[0].blockSize);
                    break;
                    case this.announceBar:
                        this.announceBarHeight = Math.round(entry.contentBoxSize[0].blockSize);
                    break;
                }
            });
            this.updateSize()
        });

        this.domObserver = new MutationObserver(() => {
            let announceBar = document.getElementById('qab_container');
            if (announceBar && !this.announceBar) {
                this.announceBar = announceBar;
                this.resizeObserver.observe(this.announceBar);
            } else if (!announceBar && this.announceBar) {
                this.resizeObserver.unobserve(this.announceBar);
                this.announceBar = null;
                this.announceBarHeight = 0;
                this.updateSize()
            }
        });

        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.menuBar);
        this.domObserver.observe(document.body, { childList: true, subtree: true });
    }

    updateSize() {
        if (this.headerHeight > 0 && this.barHeight > 0) {
            this.el.style.top = '-' + ((this.headerHeight - (this.announceBarHeight || 0)) - this.barHeight) + 'px';
        }
    }
}

window.header = new SiteHeader(document.querySelector('.shopify-section--header'));